import * as React from "react";
import { HeaderContext } from "../../helpers/header-provider/header-provider.mjs";
const MainHeader = (props) => {
  const { headerHeight } = React.useContext(HeaderContext);
  const { children, className } = props;
  const BEM = () => {
    const classArray = ["main__header"];
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  const getStyle = () => {
    return {
      paddingTop: headerHeight
    };
  };
  return /* @__PURE__ */ React.createElement("div", { className: BEM(), style: headerHeight ? getStyle() : void 0 }, children);
};
export {
  MainHeader
};
